var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Box, ToggleButtonGroup, ToggleButton, Typography, MenuItem, useTheme, FormControlLabel, Switch } from '@mui/material';
import { useState } from 'react';
import { X } from 'react-feather';
import useTranslate from '../../../../../localization/helpers';
var SortFolderDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, sortOptions = _a.sortOptions, isSubFolder = _a.isSubFolder, onApplySort = _a.onApplySort;
    var translate = useTranslate().translate;
    var theme = useTheme();
    var _b = __read(useState('asc'), 2), sortDirection = _b[0], setSortDirection = _b[1];
    var _c = __read(useState('name'), 2), sortField = _c[0], setSortField = _c[1];
    var _d = __read(useState('activeOnTop'), 2), assetSortPreference = _d[0], setAssetSortPreference = _d[1];
    var _e = __read(useState(false), 2), showInactiveAssets = _e[0], setShowInactiveAssets = _e[1];
    var handleDirectionChange = function (_, newValue) {
        if (newValue !== null) {
            setSortDirection(newValue);
        }
    };
    var handleAssetSortChange = function (_, newValue) {
        if (newValue !== null) {
            setSortField('');
            setAssetSortPreference(newValue);
        }
    };
    var onApplyButtonClick = function () {
        setSortField('');
        setSortDirection('asc');
        setShowInactiveAssets(false);
        onApplySort(sortField, sortDirection, assetSortPreference);
    };
    var onCloseButtonClick = function () {
        setSortField('');
        setSortDirection('asc');
        setShowInactiveAssets(false);
        onClose();
    };
    return (_jsxs(Dialog, { fullWidth: true, open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [translate('common.sortFolders'), _jsx(IconButton, { color: 'inherit', onClick: onCloseButtonClick, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 2, children: [_jsxs(ToggleButtonGroup, { sx: {
                                my: 1,
                                maxHeight: 36,
                                width: { xs: '100%', md: 'auto' }
                            }, exclusive: true, value: sortDirection, onChange: handleDirectionChange, "aria-label": 'sort direction', children: [_jsx(ToggleButton, { size: 'small', value: 'asc', sx: {
                                        borderBottomLeftRadius: '8px !important',
                                        borderTopLeftRadius: '8px !important',
                                        flex: '1 1 auto',
                                        '&.Mui-selected': {
                                            backgroundColor: '#009983 !important',
                                            color: 'white'
                                        }
                                    }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Icon, { icon: 'material-symbols:arrow-upward' }), _jsx(Typography, { variant: 'body2', children: translate('actions.ascending') })] }) }), _jsx(ToggleButton, { size: 'small', value: 'desc', sx: {
                                        borderBottomRightRadius: '8px !important',
                                        borderTopRightRadius: '8px !important',
                                        flex: '1 1 auto',
                                        '&.Mui-selected': {
                                            backgroundColor: '#009983 !important',
                                            color: 'white'
                                        }
                                    }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Icon, { icon: 'material-symbols:arrow-downward' }), _jsx(Typography, { variant: 'body2', children: translate('actions.descending') })] }) })] }), _jsx(Typography, { variant: 'subtitle2', children: translate('actions.sortField') }), _jsx(Box, { maxHeight: '184px', sx: { overflowY: 'auto' }, children: _jsx(Box, { sx: {
                                    borderRadius: '8px',
                                    overflow: 'hidden'
                                }, children: sortOptions.map(function (option) { return (_jsxs(MenuItem, { onClick: function () {
                                        setShowInactiveAssets(false);
                                        setSortField(option.value);
                                    }, sx: {
                                        py: 1,
                                        borderBottom: option.value !== sortOptions[sortOptions.length - 1].value
                                            ? "1px solid ".concat(theme.palette.divider)
                                            : 'none',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }, children: [_jsx(Typography, { variant: 'body2', children: option.label }), sortField === option.value && (_jsx(Icon, { icon: 'material-symbols:check', color: theme.palette.primary.main }))] }, option.value)); }) }) }), !isSubFolder && (_jsxs(_Fragment, { children: [' ', _jsx(FormControlLabel, { control: _jsx(Switch, { checked: showInactiveAssets, onChange: function (e) {
                                            if (e.target.checked) {
                                                setSortField('');
                                            }
                                            setShowInactiveAssets(e.target.checked);
                                        } }), label: translate('common.showInactiveAssets') }), showInactiveAssets && (_jsxs(ToggleButtonGroup, { sx: {
                                        my: 1,
                                        maxHeight: 36,
                                        width: { xs: '100%', md: 'auto' }
                                    }, exclusive: true, value: assetSortPreference, onChange: handleAssetSortChange, "aria-label": 'active-inactive sort', children: [_jsx(ToggleButton, { size: 'small', value: 'activeOnTop', sx: {
                                                borderBottomLeftRadius: '8px !important',
                                                borderTopLeftRadius: '8px !important',
                                                flex: '1 1 auto',
                                                '&.Mui-selected': {
                                                    backgroundColor: '#009983 !important',
                                                    color: 'white'
                                                }
                                            }, children: _jsx(Typography, { variant: 'body2', children: translate('common.activeOnTop') }) }), _jsx(ToggleButton, { size: 'small', value: 'inactiveOnTop', sx: {
                                                borderBottomRightRadius: '8px !important',
                                                borderTopRightRadius: '8px !important',
                                                flex: '1 1 auto',
                                                '&.Mui-selected': {
                                                    backgroundColor: '#009983 !important',
                                                    color: 'white'
                                                }
                                            }, children: _jsx(Typography, { variant: 'body2', children: translate('common.inActiveOnTop') }) })] })), ' '] }))] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onCloseButtonClick, variant: 'outlined', color: 'inherit', children: translate('actions.close') }), _jsx(Button, { color: 'inherit', variant: 'contained', onClick: onApplyButtonClick, children: translate('actions.applySorting') })] })] }));
};
export default SortFolderDialog;
